import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { preferencesSlice } from "./slices/preferencesSlice";
import { filterReducer } from "../api/search/filterReducer";
import { searchBarSlice } from "./slices/searchBarSlice";
import { prefOptionsSlice } from "./slices/prefOptionsSlice";
import { miscSlice } from "./slices/miscSlice";
// Temporarily disable while migrating to JAPI
import { menuSlice } from "./slices/menuSlice";

const reducers = (history) =>
  combineReducers({
    preferences: preferencesSlice.reducer,
    prefOptions: prefOptionsSlice.reducer,
    filter: filterReducer.reducer,
    searchbar: searchBarSlice.reducer,
    misc: miscSlice.reducer,
    menu: menuSlice.reducer,
    router: connectRouter(history),
  });

export default reducers;
